import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { usePageContext } from '@src/config';
import type { ListKeys } from '@src/constants/microcredits';
import { fetchClientOffers } from '@src/reducers/microcredits';

export const useLoadClientOffers = (listKey?: ListKeys) => {
  const dispatch = useDispatch();

  const { listKey: internalKey } = usePageContext();

  return useCallback(
    (queryOptions: Record<string, any>, isPersistOffers?: boolean) => {
      dispatch(fetchClientOffers({ key: listKey || internalKey, userQuery: queryOptions, isPersistOffers }));
    },
    [dispatch, listKey, internalKey],
  );
};
